
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ProfileButton } from "./ProfileButton";
import { useAuth } from "@/contexts/AuthContext";
import { MobileLandingMenu } from "./MobileLandingMenu";
import { useIsMobile } from "@/hooks/use-mobile";

export function EmployeeLandingNav() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isMobile = useIsMobile();
  
  const menuItems = [
    {
      label: "Jobs",
      onClick: () => navigate("/jobs")
    },
    {
      label: "For Employers",
      onClick: () => navigate("/")
    }
  ];

  return (
    <div className="flex items-center space-x-4">
      {isMobile ? (
        <MobileLandingMenu items={menuItems} />
      ) : (
        <>
          <Button 
            variant="ghost" 
            className="text-muted-foreground hover:text-foreground hover:bg-accent transition-colors duration-200" 
            onClick={() => navigate("/jobs")}
          >
            Jobs
          </Button>
          <Button 
            variant="ghost" 
            className="text-muted-foreground hover:text-foreground hover:bg-accent transition-colors duration-200" 
            onClick={() => navigate("/")}
          >
            For Employers
          </Button>
        </>
      )}
      {user ? (
        <ProfileButton />
      ) : (
        <Button 
          variant="default"
          onClick={() => navigate("/login")}
          className="bg-secondary hover:bg-secondary-hover text-secondary-foreground transition-colors duration-200 rounded-sm"
        >
          Sign In
        </Button>
      )}
    </div>
  );
}
